<template>
    <div :data-designer-component-id="component_id" :id="'radio--' + component_id" class="stylesoption form-group" v-show="options_loaded && passed_filter">
        <label v-if="!loading">
            {{ title }}
        </label>
        <div class="radios _switches" v-if="!loading">
            <div v-for="option in filtered_option_list" class="radio">
                <label>
                    <input type="radio" v-model="localTarget" :name="'radio_' + component_id" :value="option.value" class="skip_icheck"/>
                    <span class="radio-label">{{ option.label }}</span>
                </label>
            </div>
        </div>
        <div v-if="loading">
            <p>Loading Options</p>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./Question.vue";
    import { nextTick } from "vue";

    export default {
        mixins: [
            Question
        ],
        watch: {
            'filtered_option_list': function (new_val, old_val) {
                nextTick(()=>{
                    var options = $('#radio--' + this.component_id + ' input');

                    options.on('change', (e) => {
                        this.localTarget = parseInt(e.target.value);
                    });
                });
            }
        }
    }
</script>
